import Card from "../../components/Cards/Card";
import PDF from "../RegrasCamapnha/Regras-Incentivos-Programa-de-Excelência-FY25.pdf.pdf";

export function RegrasCampanhas() {
  return (
    <Card style={{ backgroundColor: "#ebf3fb", height: "100%" }}>
      <div className="container-titles">
        <h3 style={{ margin: "10px 0 34px" }}>Regras da Campanha</h3>
      </div>
      <iframe
        title="pdf-regras-da-campanha"
        height={"642px"}
        width={"80%"}
        style={{ margin: "auto" }}
        // src="https://www.thecampusqdl.com/uploads/files/pdf_sample_2.pdf"
        src={PDF}
      />
    </Card>
  );
}
